export const env = {
    production: false,
    debugMode: true,
    url_base: 'https://dev.api.catastroantioquia-mas.com',
    api: '/api',
    landing: '/landing',
    perfil_usuario: '/perfil-usuario',
    administracion: '/administracion',
    crm: '/crm',
    asistente: '/asistente',
}

export const python = {
    production: false,
    debugMode: true,

    url_base: 'https://dev.api.catastroantioquia-mas.com:5001/ask',
    url_asis: 'https://dev.catia.catastroantioquia-mas.com:5002/ask',
    url_var_env_crm:'https://dev.api.catastroantioquia-mas.com:5000/ask',
    catia: '/catia',
}

export const python_countries = {
    production: false,
    debugMode: true,

    url_base: 'https://dev.api.catastroantioquia-mas.com:5001',
    api : '/api',
}
